import script from "./allservices.vue?vue&type=script&setup=true&lang=js"
export * from "./allservices.vue?vue&type=script&setup=true&lang=js"

import "./allservices.vue?vue&type=style&index=0&id=26d1317e&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d1317e"]])

export default __exports__